<div class="sidebar" [class.minimized]="appService.minimized">
  <div
    class="toggler"
    (click)="toggleSidebarMinimized()"
    [pTooltip]="appService.minimized ? 'Expandir menú' : 'Contraer menú'"
    tooltipPosition="right"
  >
    <i class="pi pi-angle-left" *ngIf="!appService.minimized"></i>
    <i class="pi pi-angle-right" *ngIf="appService.minimized"></i>
  </div>

  <img src="img/nodes_dark.png" class="nodes" />

  <div
    *ngIf="!appService.minimized"
    [class.showUp]="!appService.minimized"
    class="items"
  >
    <div class="all-items">
      <div class="item" [routerLink]="['dashboard']" routerLinkActive="active">
        <i class="pi pi-home"></i> Inicio
      </div>
      <div class="separator"></div>
      <div
        class="item"
        [routerLink]="['transactions']"
        routerLinkActive="active"
      >
        <i class="pi pi-list-check"></i> Transacciones
      </div>

      <!-- <div class="item" [routerLink]="['cashins']" routerLinkActive="active">
        <i class="pi pi-plus-circle"></i> Cashins
      </div>

      <div class="item" [routerLink]="['transfers']" routerLinkActive="active">
        <i class="pi pi-arrow-right"></i> Transferencias Internas
      </div> -->

      <div class="item" [routerLink]="['exchanges']" routerLinkActive="active">
        <i class="pi pi-arrow-right-arrow-left"></i> Exchanges
      </div>

      <div
        class="item"
        [routerLink]="['payment-links']"
        routerLinkActive="active"
      >
        <i class="pi pi-link"></i> Links de pago
      </div>

      <div class="separator"></div>

      <div
        *ngIf="authService.hasRole(roles.Admin)"
        class="item"
        [routerLink]="['swaps']"
        routerLinkActive="active"
      >
        <i class="pi pi-shopping-cart"></i> Swaps
      </div>

      <!-- <div
      class="item"
      [routerLink]="['balances', 'VES']"
      *ngIf="authService.hasRole(roles.Admin)"
      routerLinkActive="active"
    >
      <i class="pi pi-wallet"></i> Balances VES
    </div> -->

      <div
        class="item"
        [routerLink]="['movements']"
        *ngIf="authService.hasRole(roles.Admin)"
        routerLinkActive="active"
      >
        <i class="pi pi-building-columns"></i> Movimientos
      </div>

      <div
        class="item"
        [routerLink]="['payment-declarations']"
        *ngIf="authService.hasRole(roles.Admin)"
        routerLinkActive="active"
      >
        <i class="pi pi-receipt"></i> Transacciones pendientes
      </div>

      <div
        class="item"
        [routerLink]="['support-tickets']"
        routerLinkActive="active"
      >
        <i class="pi pi-ticket"></i> Tickets de soporte
      </div>

      <div
        class="item"
        [routerLink]="['complaints']"
        *ngIf="authService.hasRole(roles.Admin)"
        routerLinkActive="active"
      >
        <i class="pi pi-book"></i> Libro de Reclamaciones
      </div>

      <div
        class="item"
        [routerLink]="['rates']"
        *ngIf="authService.hasRole(roles.Admin)"
        routerLinkActive="active"
      >
        <i class="pi pi-percentage"></i> Tasas consultadas
      </div>

      <div
        class="item"
        [routerLink]="['fees']"
        *ngIf="
          authService.canViewUserFees() ||
          userService.hasPlatformService(['fees:visualize', 'fees:manage'])
        "
        routerLinkActive="active"
      >
        <i class="pi pi-wallet"></i> Fees de usuarios
      </div>

      <div
        class="item"
        (click)="appService.triggerExchangeRateCalculator(true)"
      >
        <i class="pi pi-calculator"></i> Tasador
      </div>

      <div
        class="item"
        [routerLink]="['upload']"
        *ngIf="authService.hasRole(roles.Admin)"
        routerLinkActive="active"
      >
        <i class="pi pi-upload"></i> Procesamiento Ecuador
      </div>

      <div
        *ngIf="authService.hasRole(roles.Admin)"
        class="item"
        [routerLink]="['verifications']"
        routerLinkActive="active"
      >
        <i class="pi pi-id-card"></i> Verificaciones
      </div>

      <div
        *ngIf="shouldShowVerificationRequest()"
        class="item"
        [routerLink]="['verification-request']"
        routerLinkActive="active"
      >
        <i class="pi pi-user-plus"></i> Solicitar verificación
      </div>

      <div
        *ngIf="authService.hasRole(roles.Admin)"
        class="item"
        [routerLink]="['bank-transactions']"
        routerLinkActive="active"
      >
        <i class="pi pi-arrow-right-arrow-left"></i> Transacciones bancarias
        (VZLA)
      </div>

      <div
        class="item"
        [routerLink]="['virtual-cards']"
        routerLinkActive="active"
      >
        <i class="pi pi-credit-card"></i> Tarjetas virtuales
      </div>

      <div
        *ngIf="authService.canViewUsers()"
        class="item"
        [routerLink]="['users']"
        routerLinkActive="active"
      >
        <i class="pi pi-user"></i> Usuarios
      </div>

      <div
        *ngIf="authService.canViewPlatformServices()"
        class="item"
        [routerLink]="['platform-services']"
        routerLinkActive="active"
      >
        <i class="pi pi-shield"></i> Permisología
      </div>

      <div
        *ngIf="authService.hasRole(roles.Admin)"
        class="item"
        [routerLink]="['base-priorities']"
        routerLinkActive="active"
      >
        <i class="pi pi-sort-amount-up"></i> Prioridades base
      </div>

      <div
        *ngIf="authService.hasRole(roles.Admin)"
        class="item"
        [routerLink]="['white-labels']"
        routerLinkActive="active"
      >
        <i class="pi pi-building"></i> White labels
      </div>

      <div
        *ngIf="authService.canViewWhiteLabelRoles()"
        class="item"
        [routerLink]="['white-label-roles']"
        routerLinkActive="active"
      >
        <i class="pi pi-users"></i> Roles (White label)
      </div>

      <div class="item" [routerLink]="['settings']" routerLinkActive="active">
        <i class="pi pi-cog"></i> Configuración
      </div>

      <a
        class="item"
        href="https://www.swappers.app/libro-de-reclamaciones?v=1"
        target="_blank"
        rel="noopener"
      >
        <i class="pi pi-external-link"></i> Presentar reclamo o queja
      </a>
    </div>
    <div class="separator mt-auto"></div>

    <div
      class="balance-items"
      [class.balance-items-collapsed]="hideAllBalances"
    >
      <div class="balance-toolbar">
        <button
          type="button"
          class="balance-toggle"
          (click)="toggleHideZeroBalances()"
          [pTooltip]="
            hideZeroBalances
              ? 'Mostrar todos los balances'
              : 'Ocultar saldos en 0'
          "
          tooltipPosition="top"
        >
          {{ hideZeroBalances ? "Mostrar todos" : "Ocultar saldos en 0" }}
        </button>

        <button
          type="button"
          class="balance-toggle balance-toggle-icon"
          (click)="toggleHideAllBalances()"
          [pTooltip]="
            hideAllBalances
              ? 'Mostrar todos los balances'
              : 'Ocultar todos los balances'
          "
          tooltipPosition="top"
        >
          <i
            class="pi"
            [ngClass]="hideAllBalances ? 'pi-angle-up' : 'pi-angle-down'"
          ></i>
        </button>
      </div>

      <ng-container *ngIf="!hideAllBalances">
        <!-- FIAT -->
        <div class="balances-column">
          <div
            class="balance-container"
            *ngFor="let currency of getCurrenciesByType('fiat')"
            (click)="viewCurrency(currency.currency)"
          >
            <div class="rs">
              <div class="currency-img">
                <img
                  class="balance-img"
                  [src]="'img/currencies/' + currency.id + '.png'"
                />
              </div>
            </div>
            <div class="ls">
              <div class="balance" *ngIf="currency.currency === 'VES'">
                <div class="balance-value">
                  <div class="currency">{{ currency.shortname }}</div>
                  <div class="amount">{{ getDisplayBalance(currency) }}</div>
                </div>
              </div>
              <div class="balance" *ngIf="currency.currency !== 'VES'">
                <div class="balance-value">
                  <div class="currency">{{ currency.shortname }}</div>
                  <div class="amount">{{ getDisplayBalance(currency) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CRYPTO -->
        <div class="balances-column">
          <div
            class="balance-container"
            *ngFor="let currency of getCurrenciesByType('crypto')"
            (click)="viewCurrency(currency.currency)"
          >
            <div class="currency-img">
              <img
                [src]="'img/currencies/' + currency.id + '.png'"
                class="balance-img"
              />
            </div>

            <div class="balance">
              <div class="balance-value">
                <div class="currency">{{ currency.shortname }}</div>
                <div class="amount">{{ getDisplayBalance(currency) }}</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
